import { render, staticRenderFns } from "./demoCoursePPT.vue?vue&type=template&id=0e4d1f48&scoped=true"
import script from "./demoCoursePPT.vue?vue&type=script&lang=js"
export * from "./demoCoursePPT.vue?vue&type=script&lang=js"
import style0 from "./demoCoursePPT.vue?vue&type=style&index=0&id=0e4d1f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d1f48",
  null
  
)

export default component.exports